export enum FileExtensions {
  DOC = 'application/msword',
  PDF = 'application/pdf',
  JPG = 'image/jpeg',
  PNG = 'image/png',
  GIF = 'image/gif',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  XLS = 'application/vnd.ms-excel',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  XML = 'application/xml',
  XMLTEXT = 'text/xml',
  WOFF = 'application/font-woff',
  JSON = 'application/json',
  PPT = 'application/vnd.ms-powerpoint',
  PPTX = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  JPEG = 'image/jpeg',
  TXT = 'text/plain'
};
